import { createToaster } from '@ark-ui/react/toast'

const toaster = createToaster({
  placement: 'bottom',
  duration: 5_000,
})

export { toaster as toast }
